import { render, staticRenderFns } from "./SortView.vue?vue&type=template&id=6a9b5678&scoped=true&"
import script from "./SortView.vue?vue&type=script&lang=ts&"
export * from "./SortView.vue?vue&type=script&lang=ts&"
import style0 from "./SortView.vue?vue&type=style&index=0&id=6a9b5678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9b5678",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
